import { PartnerConfiguration } from '@percent/hosted-validation-form/app/HostedForm/HostedForm.types';

import { HostedFormStep } from './../HostedForm.types';

// Steps that follow the email step. OTP sits between email and the rest of the flow,
// and is only part of it when the hosted form detail has `otpEnabled: true`.
export const getStepAfterOtp = (partnerConfig?: PartnerConfiguration): HostedFormStep =>
  partnerConfig?.configuration?.partnerFields?.length ? HostedFormStep.PARTNER_FIELDS : HostedFormStep.TERMS;

export const getStepAfterEmail = (partnerConfig?: PartnerConfiguration): HostedFormStep =>
  partnerConfig?.configuration?.otpEnabled ? HostedFormStep.OTP : getStepAfterOtp(partnerConfig);
